import { VideoMarkerIcon } from './VideoMarkerIcon';

/**
 * author: Simran
 * id 08B1B983-F8CC-4CE2-B9FA-4A292766BE31
 * name video-marker
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-marker.svg
 * tags
 * - Video / Movie 
 * - Navigation 
 */
export const VideoLocationIcon = VideoMarkerIcon;
export default VideoLocationIcon